import { _ } from "../../../../core/polyglot/polyglot.js";
import AbstractPeriodColumn from "./AbstractPeriodColumn.js";

/**
 * Closing balance report column.
 */
class ClosingBalanceColumn extends AbstractPeriodColumn {
	accept(visitor) {
		return visitor.visitClosingBalanceColumn(this);
	}

	isBalanceColumn() {
		return true;
	}

	_getDefaultTitle() {
		return _("CB {period}", {
			period: super._getDefaultTitle(),
		});
	}

	_operation() {
		return "closingBalance";
	}

	static getType() {
		return "ClosingBalanceColumn";
	}
}

export default ClosingBalanceColumn;
